<section id="nav_mobile" class="overlay-mobile-navigation" [@navMobileAnimation]='navMobileStatus'>
	<nav class="nav-mobile">
		<div class="top">
			<div class="ico-close-wrapper">
				<button mat-icon-button (click)="closeNav()" class='custom-mat-icon-button button-ico-close'>
					<mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
				</button>
			</div>
			<div class="logo blue"></div>
			<a [routerLink]="['/main/dashboard']" routerLinkActive="router-link-active" class="ico-home">
				<mat-icon svgIcon="ico-home" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
			</a>
		</div>
		<div class="body">
      <mat-accordion #navBody="matAccordion" displayMode="flat" class="custom-mat-accordion list-navigation">
        <mat-expansion-panel *ngFor="let panel of collectionOfNavOption" class="custom-mat-expansion-panel">
          <mat-expansion-panel-header expandedHeight="64px" collapsedHeight="64px" class="custom-mat-expansion-panel-header">
            <mat-panel-title class="custom-mat-expansion-panel-header-title">
              <div matLine class="ico-prefix">
                <mat-icon svgIcon="{{panel.iconPrefix}}" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
              </div>
              <label matLine>{{panel.title}}</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list *ngIf="panel.options.length > 0" class="custom-mat-list list-navigation-options">
            <mat-list-item *ngFor="let option of panel.options" class="custom-mat-list-item">
              <a mat-list-item matLine [routerLink]="option.url" routerLinkActive="router-link-active" class="custom-mat-link nav-option" [disabled]="!option.hasAccess">{{option.displayName}}</a>
            </mat-list-item>
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>
		</div>
		<div class="account">
			<mat-list class="custom-mat-list list-navigation-account">
				<a mat-list-item class="custom-mat-link nav-option nav-option-account">
					<span class="avatar">
						<figure [style.background-image]="'url(' + userPicture + ')'"></figure>
					</span>
					<div class="user-profile">
						<label class="user-name">{{ userFirstName }} {{ userLastName }}</label>
						<label class="account-name">{{ companyName }}</label>
					</div>
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-next" class="custom-mat-icon ico-size ico-3xs ico-next"></mat-icon>
					</div>
				</a>
				<a mat-list-item [routerLink]="['/login/switch']" routerLinkActive="router-link-active" class="custom-mat-link nav-option">
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-switch" class="custom-mat-icon ico-size ico-xs"></mat-icon>
					</div>
					<label>Switch Company</label>
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-next" class="custom-mat-icon ico-size ico-3xs ico-next"></mat-icon>
					</div>
				</a>
				<a mat-list-item [routerLink]="['/account']" routerLinkActive="router-link-active" class="custom-mat-link nav-option">
          <div class="svg-wrapper">
            <mat-icon svgIcon="ico-user-account" class="custom-mat-icon ico-size ico-xs ico-prefix"></mat-icon>
          </div>
					<label>Account</label>
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-next" class="custom-mat-icon ico-size ico-3xs ico-next"></mat-icon>
					</div>
				</a>
				<a mat-list-item [routerLink]="['/main/settings/advanced']" routerLinkActive="router-link-active" class="custom-mat-link nav-option nav-option-help">
          <div class="svg-wrapper">
            <mat-icon svgIcon="ico-settings" class="custom-mat-icon ico-size ico-xs"></mat-icon>
          </div>
					<label>Advanced Settings</label>
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-next" class="custom-mat-icon ico-size ico-3xs ico-next"></mat-icon>
					</div>
				</a>
				<a mat-list-item class="custom-mat-link nav-option nav-option-logout" (click)="onLogout()">
					<div class="svg-wrapper">
						<mat-icon svgIcon="ico-signout" class="custom-mat-icon ico-size ico-xs"></mat-icon>
					</div>
					<label>Logout</label>
				</a>
			</mat-list>
		</div>
		<div class="footer">
			<p>© Rebillia LLC. Privacy and Terms</p>
		</div>
	</nav>
</section>
